module.exports = __webpack_public_path__ + "static/media/panel_header_bkgrd.31910c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/panel_header_bkgrd.png
// module id = 608
// module chunks = 0